export default __webpack_public_path__ + "media/images/temporary/mu-run-7-a5d4e08f2403560d899ad2750cd27071.jpg";